import Immutable from 'immutable';
import moment from 'moment';

import {
  SET_INSTITUTION_REPORT_DATA,
  SET_START_DATE,
  SET_END_DATE,
} from './actions';

export function InstitutionReport(state = new Immutable.Map(), action = {}) {
  switch (action.type) {
    case SET_INSTITUTION_REPORT_DATA: {
      const institutionName = action.institutionReportData.name;
      const dateFormat = 'DD/MM/YYYY';
      const currDate = moment(new Date()).format(dateFormat);
      return state
        .set('institution', Immutable.fromJS(institutionName))
        .set('startDate', currDate)
        .set('endDate', currDate);
    }
    case SET_START_DATE: {
      const startDate = action.date;
      return state.set('startDate', Immutable.fromJS(startDate));
    }
    case SET_END_DATE: {
      const endDate = action.date;
      return state.set('endDate', Immutable.fromJS(endDate));
    }
    default: {
      return state;
    }
  }
}
